import type { UseInventoryListByIdFetch } from '@openx/types/targeting/targetingHookTypes.ts';

// todo EXCH-12155
export const useInventoryListByIdFetch: UseInventoryListByIdFetch = (_?: string | null) => {
  return {
    inventoryList: null,
    loading: false,
  };
};
